import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {ArbitraryEmailDto, EmailDetail, PointEmailDto} from "../../../../../../generated-model/model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {ArbitraryEmailResource} from "../../../../../service/ArbitraryEmailResource";
import {ToastService} from "../../../../../shared/commons/toast/toast-service";
import {emailPattern, markInvalidControlsAsDirtyAndTouched} from '../../../../../app.constants';
import {PointEmailResource} from "../../../../../service/PointEmailResource";
import {NotFoundComponent} from "../../../../../shared/not-found/not-found.component";
import {SharedCommonModule} from "../../../../../shared/commons/shared-common.module";
import {NgForOf} from "@angular/common";


@Component({
  selector: 'app-manage-email-point-modal',
  standalone: true,
  imports: [
    FormsModule,
    NotFoundComponent,
    ReactiveFormsModule,
    SharedCommonModule,
  ],
  templateUrl: './manage-email-point-modal.component.html',
  styleUrl: './manage-email-point-modal.component.scss'
})
export class ManageEmailPointModalComponent implements OnInit{

  @Input() item: PointEmailDto
  emailInput: string;
  activeModal = inject(NgbActiveModal);
  protected readonly emailPattern = emailPattern;
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  pointEmailResource = inject(PointEmailResource);
  toastService = inject(ToastService);

  ngOnInit(): void {

  }

  submit() {
    let formValid = this.updateFormAndValidity(this.form);
    if (formValid) {
      this.pointEmailResource.save(this.item).subscribe(e => {
        this.toastService.showSuccess('บันทึกสำเร็จ');
        this.activeModal.close(e);
      });
    }
  }

  remove(item: EmailDetail) {
    this.item.emails = this.item.emails.filter(e => e !== item);
  }

  updateFormAndValidity(form: NgForm): boolean {
    if (!form.valid) {
      markInvalidControlsAsDirtyAndTouched(form)
    }
    return form.valid
  }

  add() {
    if (this.emailInput?.trim()) {
      let formValid = this.updateFormAndValidity(this.form);
      if (formValid) {
        const newEmail: EmailDetail = {
          email: this.emailInput.trim(),
          send: true  // default value
        };
        this.item.emails.push(newEmail);
        this.emailInput = ''; // Clear input
      }
    }
  }

}
